(() => {
  const reel = document.getElementById('reel');
  if (!reel) return;
  const figs = [...reel.querySelectorAll('figure')];
  const arrows = document.querySelectorAll('.k-ctrl button');
  const count = document.getElementById('count');
  if (!figs.length || arrows.length < 2) return;

  const current = () => {
    const left = reel.getBoundingClientRect().left + parseFloat(getComputedStyle(reel).paddingLeft);
    let idx = 0, best = Infinity;
    figs.forEach((f, i) => {
      const d = Math.abs(f.getBoundingClientRect().left - left);
      if (d < best) { best = d; idx = i; }
    });
    return idx;
  };

  const sync = () => {
    const max = reel.scrollWidth - reel.clientWidth - 2;
    const atEnd = reel.scrollLeft >= max;
    arrows[0].disabled = reel.scrollLeft <= 2;
    arrows[1].disabled = atEnd;
    if (count) count.textContent = (atEnd ? figs.length : current() + 1) + ' / ' + figs.length;
  };

  arrows.forEach(b => b.addEventListener('click', () => {
    const i = Math.max(0, Math.min(figs.length - 1, current() + Number(b.dataset.dir)));
    reel.scrollTo({ left: figs[i].offsetLeft - figs[0].offsetLeft, behavior: 'smooth' });
  }));

  reel.addEventListener('keydown', e => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    e.preventDefault();
    arrows[e.key === 'ArrowRight' ? 1 : 0].click();
  });

  reel.addEventListener('scroll', sync, { passive: true });
  addEventListener('resize', sync);
  figs.forEach(f => { const img = f.querySelector('img'); if (img) img.addEventListener('load', sync); });
  sync();
})();
